import React, {useEffect,useState} from 'react'
import SecurityScorecardMappingForm from './SecurityScorecardMappingForm';
import SecurityScorecardCredentialsForm from './SecurityScorecardCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { Sorters } from 'utils/tableUtils';

export default function SecurityScorecardConfigListing(props) {

    const [loginConfig,setLoginConfig] = useState([]);

    useEffect(()=>{
        if(props.loginConfigList && props.loginConfigList.length){
            let value = props.loginConfigList.map((login)=> {
                const {username, ...restConfig} = login;
                return { 
                   ...restConfig,
                   accessKey: username
                }
            })
        setLoginConfig(value);
        } else {
            setLoginConfig([])
        }
    },[props.loginConfigList])

    const columns = [
       {
          title: "Portfolio",
          dataIndex: "portfolioName",
          sorter: Sorters.STRING("portfolioName"),
          width: 150,
       },{
         title: "Company",
         dataIndex: "companyName",
         sorter: Sorters.STRING("companyName"),
         width: 150,
       }
    ]


    return (
        <GenericPullConfigListing
            {...props}
            loginConfigList={loginConfig}
            toolName={props.name}
            MappingForm={SecurityScorecardMappingForm}
            CredentialsForm={SecurityScorecardCredentialsForm}
            extraColumns={columns}
        />
    )
}